export default __webpack_public_path__ + "assets/images/4a565733acf0cacf1ce0953041e920ab.png";